import * as actionTypes from "./actionTypes";
import axiosRequest from "../../axios-request/request.methods";

//bi fetched
export const fetchHealthDetails = (payload) => {
  return {
    type: actionTypes.FETCH_HEALTH_DETAILS,
    formData: payload,
  };
};
// bi started
export const editHealthDetailsStarted = () => {
  // //console.log(formData)
  return {
    type: actionTypes.FETCH_HEALTH_DETAILS_START,
  };
};

export const editHealthDetailsSuccess = (formData, succMsg, res) => {
  return {
    type: actionTypes.FETCH_HEALTH_DETAILS_SUCESS,
    formData: formData,
    succMsg: "Proposal Updated Successfully",
    response: res,
  };
};

// export const fetchHealthDetailsSuccess = (payload, apiPath) => {
//   return async (dispatch) => {
//     dispatch(editHealthDetailsStarted());
//     axiosRequest.put(apiPath, payload).then((res) => {
//       //console.log(res);
//      dispatch(fetchHealthDetails(res?.HealthDetailsSection));
//     });
//   };
// };

export const fetchHealthDetailsSuccess = (payload, apiPath) => {
  return async (dispatch) => {
    dispatch(editHealthDetailsStarted());
    try {
      const res = await axiosRequest.put(apiPath, payload);
      if (res) {
        dispatch(fetchHealthDetails(res?.HealthDetailsSection));
        return res; // Return the response
      } else {
        return null;
      }
    } catch (err) {
      // Handle errors here if needed
      console.error("Error in fetchHealthDetailsSuccess:", err);
      throw err; // Re-throw the error to propagate it to the caller
    }
  };
};

export const editHealthDetailsFail = (errMsg) => {
  return {
    type: actionTypes.FETCH_HEALTH_DETAILS_FAIL,
    error: errMsg,
  };
};
